import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { Badges } from "../../../AbstractElements";
import { BorderSecondaryTitle } from "../../../Constants/Constants";
import { BorderPrimarySubTitle, BorderSecondaryData } from "../../../Data/BonusUi/CreativeCard";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const BorderSecondary = () => {
  return (
    <Col xs="12" xl="4">
      <Card className="height-equal">
        <CommonCardHeader title={BorderSecondaryTitle} span={BorderPrimarySubTitle} headClass="border-l-secondary border-2 pb-0" />
        <CardBody className="scroll-demo">
          <ListGroup numbered className="scroll-rtl">
            {BorderSecondaryData &&
              BorderSecondaryData.map((item, index) => (
                <ListGroupItem className="d-flex align-items-start flex-wrap" key={index}>
                  <div className="ms-2 me-auto">{item.text}</div>
                  <Badges color={item.class} className="rounded-pill p-2">
                    {item.text2}
                  </Badges>
                </ListGroupItem>
              ))}
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BorderSecondary;
